import { useTranslations } from 'next-intl';
import { useToast } from '@/app/components/ui/use-toast';
import { openOrRedirect } from '@/app/utils/client';

export const useGoToProfile = () => {
  const t = useTranslations();
  const { toast } = useToast();

  const goToProfile = (userId?: string) => {
    if (!userId || userId === '0') {
      toast({
        message: t('profile.logout.tip'),
        type: 'warning',
      });
      return;
    }

    openOrRedirect(`/profile/${userId}`);
  };

  return { goToProfile };
};
